import React from 'react';
import { Link } from 'react-router-dom';
import blogPosts from '../data/blogPosts';
import './Blog.css';

function Blog() {
  return (
    <section className="page blog-listing">
      <h1>Blog</h1>
      <p className="blog-intro">
        Insights on AI audit logging, compliance, and building responsible AI systems.
      </p>

      <div className="blog-posts">
        {blogPosts.map((post) => (
          <article key={post.slug} className="blog-card">
            <Link to={`/blog/${post.slug}`}>
              <h2>{post.title}</h2>
            </Link>
            <div className="blog-meta">
              <span className="blog-date">{post.date}</span>
            </div>
            <p className="blog-excerpt">{post.excerpt}</p>
            <Link to={`/blog/${post.slug}`} className="read-more">
              Read more →
            </Link>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Blog;
